module.exports = __webpack_public_path__ + "img/about01.c670285e.png";